"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Box = void 0;

var _native = _interopRequireDefault(require("styled-components/native"));

var _props = require("@sloth-system/props");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

let Box = _native.default.View`
  ${_props.paddingProps}
  ${_props.backgroundColorProps}
  ${_props.borderRadiusProps}
  ${_props.marginProps}
`;
exports.Box = Box;